module.exports = __webpack_public_path__ + "8a2b056997e8bd2821def0934a60d485.png";